var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.5H14C14.5523 5.5 15 5.94772 15 6.5V7.5H17V6.5C17 4.84315 15.6569 3.5 14 3.5H6C4.34315 3.5 3 4.84315 3 6.5V14.5C3 16.1569 4.34315 17.5 6 17.5H7V15.5H6C5.44772 15.5 5 15.0523 5 14.5V6.5C5 5.94772 5.44772 5.5 6 5.5Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.5H10C9.44772 9.5 9 9.94772 9 10.5V18.5C9 19.0523 9.44772 19.5 10 19.5H18C18.5523 19.5 19 19.0523 19 18.5V10.5C19 9.94772 18.5523 9.5 18 9.5ZM10 7.5C8.34315 7.5 7 8.84315 7 10.5V18.5C7 20.1569 8.34315 21.5 10 21.5H18C19.6569 21.5 21 20.1569 21 18.5V10.5C21 8.84315 19.6569 7.5 18 7.5H10Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.62786d94bdc2c191143fdfa363810bae.svg";
export { ForwardRef as ReactComponent };